export default "__VITE_ASSET__Dn2pf_WY__"